import { create } from 'zustand';

function readUser() {
  try {
    return JSON.parse(window.localStorage.getItem('user') || 'null');
  } catch (err) {
    return null;
  }
}

export const useSessionStore = create(set => ({
  user: readUser(),
  wakeRecovering: false,
  activeReactScreen: '',
  setUser: user => {
    try {
      if (user) window.localStorage.setItem('user', JSON.stringify(user));
      else window.localStorage.removeItem('user');
    } catch (err) {}
    set({ user });
  },
  setWakeRecovering: wakeRecovering => set({ wakeRecovering }),
  setActiveReactScreen: activeReactScreen => set({ activeReactScreen })
}));
